import { render, staticRenderFns } from "./MultiButton.vue?vue&type=template&id=47b31f08&"
import script from "./MultiButton.vue?vue&type=script&lang=js&"
export * from "./MultiButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports